import { deleteData, getData, postData, putData } from "./apiInstance";
import { AxiosResponse } from "axios";
import {
  AddCommentPayloadType,
  AddInvoiceGenerationPayloadType,
  AddOtherInvoiceGenerationPayloadType,
  ApproveInvoicePayloadType,
  AssignInvoiceColumnsToClientPayloadType,
  DeleteInvoicesListPayloadType,
  DeleteOtherInvoicesListPayloadType,
  DownloadInvoiceGenerationReportsType,
  DownloadOtherInvoicesReportsType,
  DuplicateEntriesPayloadType,
  GetAllExpensesInvoicesListPayloadType,
  GetAllMappedClientColumnsPayloadType,
  GetAllOtherInvoicesListPayloadType,
  GetAllRevenueInvoicesListPayloadType,
  GetCommentPayloadType,
  GetAllocationPayloadType,
  GetSingleInvoiceDetailsPayloadType,
  GetSingleOtherInvoiceDetailsPayloadType,
  UpdateOtherInvoiceGenerationPayloadType,
  PostAllocationPayloadListType,
  LockEntryPayloadType,
  EinvoiceDataPayloadType,
  EinvoiceRevertDataPayloadType,
  InvoiceNotesPayloadType,
  SendOverdueEmailPayloadType,
  BomDataListPayloadType,
  BomDataPayloadType,
  UniqueCheckBomTemplateNamePayloadType,
  InvoiceHistoryPayloadType,
  GetBulkUploadHistoryPayloadType,
  EWayBillDataPayloadType,
  GenerateEWayBillPayloadType,
  EWayBillCancelDataPayloadType,
  ExtendEWayBillPayloadType,
  DistanceCountPayloadType,
  EinvoiceAuthenticationDataPayloadType,
  LockEntryBomPayloadType,
  DownloadManufacturalJournalReportType,
  GetSingleInvoiceDetailsOcrPayloadType,
  UpdateEWayBillPayloadType,
  UpdateTrasporterEWayBillPayloadType,
  GetClientColumnAssignedPayloadType,
} from "../commonTypes/invoiceGenerationTypes";
import { formatDate, getCSRFToken } from "../utils/commonFunctions";
import { SingleBomDataPayloadType } from "../redux/invoiceGeneration/invoiceGenrationTypes";
import { GetGstrTwoATwoBComparePayloadType } from "../commonTypes/gstTypes";

export async function getAllInvoiceColumnsListApi(
  token: string
): Promise<AxiosResponse> {
  return await getData(`invoice-generation/all/column/list`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllMappedClientColumnListApi(
  data: GetAllMappedClientColumnsPayloadType
): Promise<AxiosResponse> {
  const { client_code, type, token } = data;

  return await getData(`invoice-generation/client/column/list`, {
    params: {
      type,
      client_code,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getBulkUploadHistoryData(
  data: GetBulkUploadHistoryPayloadType
): Promise<AxiosResponse> {
  const { clientCode, type, token, limit, offset } = data;

  return await getData(`invoice-generation/bulk-upload/history`, {
    params: {
      type,
      client_code: clientCode,
      limit,
      offset,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function assignInvoiceColumnsToClientApi(
  data: AssignInvoiceColumnsToClientPayloadType
): Promise<AxiosResponse> {
  const { token, expenses, client_code, revenues, others } = data;

  let finalData = {
    client_code,
    expenses,
    revenues,
    others,
  };

  return await postData(`invoice-generation/client/column/mapping`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function addInvoiceGenerationApi(
  data: AddInvoiceGenerationPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    type,
    rate,
    invoice_data,
    client_code,
    invoice_date,
    invoice_category,
    is_invoice_ocr_created,
    is_invoice_gstr2a2b_created
  } = data;

  invoice_data.payment.map((singleObj: any) => {
    singleObj.forEach((e: any) => {
      if (e.data_type === "date") {
        if (
          e.column_value === "" ||
          e.column_value === null ||
          e.column_value === "Invalid date"
        ) {
          return (e.column_value = "");
        } else {
          return (e.column_value = formatDate(e.column_value));
        }
      }
    });
  });

  invoice_data.primary.forEach((e: any) => {
    if (e.data_type === "date") {
      if (
        e.column_value === "" ||
        e.column_value === null ||
        e.column_value === "Invalid date"
      ) {
        return (e.column_value = "");
      } else {
        return (e.column_value = formatDate(e.column_value));
      }
    }
  });
  let finalData = {
    client_code,
    type,
    rate,
    invoice_data,
    invoice_date,
    invoice_category,
    is_invoice_ocr_created,
    is_invoice_gstr2a2b_created
  };

  return await postData(`invoice-generation/add/customer/invoice`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateInvoiceGenerationApi(
  data: any
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    invoice_id,
    invoice_data,
    invoice_date,
    is_customer_supplier_changed,
    type,
    approved,
    invoice_category,
    rate,
  } = data;

  let paymentKey: any = Object.values(invoice_data.payment);
  paymentKey.map((singleObj: any) => {
    singleObj.forEach((e: any) => {
      if (e.data_type === "date") {
        if (
          e.column_value === "" ||
          e.column_value === null ||
          e.column_value === "Invalid date"
        ) {
          return (e.column_value = "");
        } else {
          return (e.column_value = formatDate(e.column_value));
        }
      }
    });
  });

  invoice_data.primary.forEach((e: any) => {
    if (e.data_type === "date") {
      if (
        e.column_value === "" ||
        e.column_value === null ||
        e.column_value === "Invalid date"
      ) {
        return (e.column_value = "");
      } else {
        return (e.column_value = formatDate(e.column_value));
      }
    }
    if (e.column_name === "voucher_invoice_number") {
      if (e.column_value === null) {
        return (e.column_value = "");
      }
    }
  });
  let finalData = {
    client_code,
    invoice_data,
    invoice_date,
    invoice_id,
    type,
    rate,
    is_customer_supplier_changed: is_customer_supplier_changed,
    approved,
    invoice_category,
  };

  return postData(`invoice-generation/update/customer/invoice`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function copyInvoiceGenerationApi(
  data: any
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    invoice_id,
    invoice_data,
    invoice_date,
    type,
    approved,
    invoice_category,
    rate,
    is_invoice_gstr2a2b_created
  } = data;

  let paymentKey: any = Object.values(invoice_data.payment);
  paymentKey.map((singleObj: any) => {
    singleObj.forEach((e: any) => {
      if (e.data_type === "date") {
        if (
          e.column_value === "" ||
          e.column_value === null ||
          e.column_value === "Invalid date"
        ) {
          return (e.column_value = "");
        } else {
          return (e.column_value = formatDate(e.column_value));
        }
      }
    });
  });

  invoice_data.primary.forEach((e: any) => {
    if (e.data_type === "date") {
      if (
        e.column_value === "" ||
        e.column_value === null ||
        e.column_value === "Invalid date"
      ) {
        return (e.column_value = "");
      } else {
        return (e.column_value = formatDate(e.column_value));
      }
    }
    if (e.column_name === "voucher_invoice_number") {
      if (e.column_value === null) {
        return (e.column_value = "");
      }
    }
  });

  let finalData = {
    client_code,
    invoice_data,
    invoice_id,
    type,
    invoice_date,
    // approved,
    invoice_category,
    rate,
    is_invoice_gstr2a2b_created
  };

  return await postData(`invoice-generation/add/customer/invoice`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function addOtherInvoiceGenerationApi(
  data: AddOtherInvoiceGenerationPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    date_of_invoice,
    narration_in_bank,
    additional_comments,
    upload,
    payment,
    branchDetails,
  } = data;

  let finalData = {
    client_code,
    date_of_invoice,
    branch_details: {
      trade_name: branchDetails?.tradeName,
      ledger_id: branchDetails?.ledgerId,
    },
    narration_in_bank,
    additional_comments,
    upload,
    payment,
  };
  return await postData(`invoice-generation/add/others/invoice`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateOtherInvoiceGenerationApi(
  data: UpdateOtherInvoiceGenerationPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    branchDetails,
    date_of_invoice,
    narration_in_bank,
    additional_comments,
    upload,
    payment,
    others_invoice_id,
  } = data;

  let finalData = {
    others_invoice_id,
    client_code,
    branch_details: {
      trade_name: branchDetails?.tradeName,
      ledger_id: branchDetails?.ledgerId,
    },
    date_of_invoice,
    narration_in_bank,
    additional_comments,
    upload,
    payment,
  };

  return await postData(`invoice-generation/update/others/invoice`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getAllOtherInvoicesListApi(
  data: GetAllOtherInvoicesListPayloadType
): Promise<AxiosResponse> {
  const {
    client_code,
    token,
    search_value,
    limit,
    offset,
    approved,
    attachment,
    invoiceNumber,
    invoiceDate,
    comment,
    created_at_start_date,
    created_at_end_date,
    invoice_date_start_date,
    invoice_date_end_date,
  } = data;

  return await getData(`invoice-generation/others/invoice`, {
    params: {
      limit,
      offset,
      client_code,
      created_at_start_date,
      created_at_end_date,
      invoice_date_start_date,
      invoice_date_end_date,
      search_term: search_value,
      ...(comment && { comment }),
      ...(approved && { approved }),
      ...(attachment && { attachment }),
      ...(invoiceNumber && {
        invoice_voucher_number:
          invoiceNumber === "invoice_number_asc"
            ? "asc"
            : invoiceNumber === "invoice_number_desc"
            ? "desc"
            : "",
      }),
      ...(invoiceDate && {
        date_of_invoice:
          invoiceDate === "invoice_date_asc"
            ? "asc"
            : invoiceDate === "invoice_date_desc"
            ? "desc"
            : "",
      }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllExpensesInvoicesListApi(
  data: GetAllExpensesInvoicesListPayloadType
): Promise<AxiosResponse> {
  const {
    client_code,
    token,
    offset = 0,
    limit = 100,
    search_value,
    approved,
    attachment,
    invoiceNumber,
    invoiceDate,
    paymentStatus,
    comment,
    created_at_start_date,
    created_at_end_date,
    invoice_date_start_date,
    invoice_date_end_date,
  } = data;

  return await getData(`invoice-generation/customer/invoice/list`, {
    params: {
      client_code,
      type: "expenses",
      limit,
      offset,
      created_at_start_date,
      created_at_end_date,
      invoice_date_start_date,
      invoice_date_end_date,
      ...(approved && { approved }),
      ...(comment && { comment }),
      ...(attachment && { attachment }),
      ...(invoiceNumber && {
        invoice_voucher_number:
          invoiceNumber === "invoice_number_asc"
            ? "asc"
            : invoiceNumber === "invoice_number_desc"
            ? "desc"
            : "",
      }),
      ...(invoiceDate && {
        date_of_invoice:
          invoiceDate === "invoice_date_asc"
            ? "asc"
            : invoiceDate === "invoice_date_desc"
            ? "desc"
            : "",
      }),
      ...(search_value && { search_term: search_value }),
      ...(paymentStatus && { payment_status: paymentStatus }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllRevenueInvoicesListApi(
  data: GetAllRevenueInvoicesListPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    offset,
    limit = 100,
    client_code,
    search_value,
    approved,
    attachment,
    invoiceNumber,
    invoiceDate,
    paymentStatus,
    comment,
    created_at_start_date,
    created_at_end_date,
    invoice_date_start_date,
    invoice_date_end_date,
  } = data;
  return await getData(`invoice-generation/customer/invoice/list`, {
    params: {
      limit,
      offset,
      client_code,
      type: "revenues",
      created_at_start_date,
      created_at_end_date,
      invoice_date_start_date,
      invoice_date_end_date,
      ...(comment && { comment }),
      ...(approved && { approved }),
      ...(attachment && { attachment }),
      ...(search_value && { search_term: search_value }),
      ...(invoiceNumber && {
        invoice_voucher_number:
          invoiceNumber === "invoice_number_asc"
            ? "asc"
            : invoiceNumber === "invoice_number_desc"
            ? "desc"
            : "",
      }),
      ...(invoiceDate && {
        date_of_invoice:
          invoiceDate === "invoice_date_asc"
            ? "asc"
            : invoiceDate === "invoice_date_desc"
            ? "desc"
            : "",
      }),
      ...(paymentStatus && { payment_status: paymentStatus }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getSingleInvoiceDetailsApi(
  data: GetSingleInvoiceDetailsPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, type, invoice_id } = data;

  return await getData(`invoice-generation/customer/invoice`, {
    params: {
      client_code,
      type,
      invoice_id,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function postInvoiceOcrApi(
  data: GetSingleInvoiceDetailsOcrPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, type, file } = data;

  const formData = new FormData();
  formData.append("client_code", client_code?.toString());
  formData.append("invoice_type", type);
  formData.append("file", file);

  return await postData(
    `invoice-generation/optical/character/recognition/model`,
    formData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}

export async function downloadInvoiceGenerationReportsApi(
  data: DownloadInvoiceGenerationReportsType
): Promise<AxiosResponse> {
  const {
    client_code,
    start_date,
    end_date,
    type,
    date_type,
    token,
    invoice_voucher_number,
    date_of_invoice,
    attachment,
    approved,
    payment_status,
    search_term,
    payment_section,
  } = data;

  return await getData(`invoice-generation/invoice/download`, {
    params: {
      client_code,
      start_date,
      end_date,
      type,
      date_type,
      invoice_voucher_number,
      date_of_invoice,
      attachment,
      approved,
      payment_status,
      search_term,
      payment_section,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function downloadOtherInvoicesReportsApi(
  data: DownloadOtherInvoicesReportsType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    start_date,
    end_date,
    date_type,
    date_of_invoice,
    attachment,
    approved,
    search_term,
  } = data;

  return await getData(`invoice-generation/others/invoice/download`, {
    params: {
      client_code,
      start_date,
      end_date,
      date_type,
      date_of_invoice,
      attachment,
      approved,
      search_term,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getSingleOtherInvoiceDetailsApi(
  data: GetSingleOtherInvoiceDetailsPayloadType
): Promise<AxiosResponse> {
  const { client_code, token, other_id } = data;

  return await getData(`invoice-generation/others/invoice/id`, {
    params: {
      client_code,
      other_id,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function deleteInvoiceApi(
  deleteInvoice: DeleteInvoicesListPayloadType
): Promise<AxiosResponse> {
  const { token, type, invoice_id, client_code } = deleteInvoice;
  const finalData = {
    type,
    invoice_id,
    client_code,
  };
  return await deleteData(`invoice-generation/delete/customer/invoice`, {
    params: {
      ...finalData,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function deleteOtherInvoiceApi(
  deleteInvoice: DeleteOtherInvoicesListPayloadType
): Promise<AxiosResponse> {
  const { token, other_id, client_code } = deleteInvoice;
  const finalData = {
    other_id,
    client_code,
  };
  return await deleteData(`invoice-generation/delete/others/invoice`, {
    params: {
      ...finalData,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function invoiceGenerationBulkUpload(
  payload: any
): Promise<AxiosResponse> {
  const { token, client_code, type, fileData } = payload;

  const formData = new FormData();
  formData.append("client_code", client_code);
  formData.append("type", type);
  formData.append("file", fileData);
  return await postData(`invoice-generation/upload/others/invoice`, formData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
export async function invoiceGenerationSuspenseBulkUpload(
  payload: any
): Promise<AxiosResponse> {
  const { token, client_code, type, fileData, account_number, branch } =
    payload;

  const formData = new FormData();
  formData.append("client_code", client_code);
  formData.append("type", type);
  formData.append("file", fileData);
  formData.append("account_number", account_number);
  formData.append("branch", branch);
  return await postData(
    `invoice-generation/upload-suspense/others/invoice`,
    formData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function invoiceGenerationRevenuesBulkUpload(
  payload: any
): Promise<AxiosResponse> {
  const { token, client_code, type, fileData } = payload;

  const formData = new FormData();
  formData.append("client_code", client_code);
  formData.append("type", type);
  formData.append("file", fileData);
  return await postData(`invoice-generation/upload/invoices`, formData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function invoiceGenerationExpensesBulkUpload(
  payload: any
): Promise<AxiosResponse> {
  const { token, client_code, type, fileData } = payload;

  const formData = new FormData();
  formData.append("client_code", client_code);
  formData.append("type", type);
  formData.append("file", fileData);
  return await postData(`invoice-generation/upload/invoices`, formData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function checkDuplicateEntryApi(
  payload: DuplicateEntriesPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    type,
    voucher_invoice_number,
    supplier_id,
    date_of_invoice,
    operation,
    invoice_id,
  } = payload;

  return await getData(`/invoice-generation/is/duplicate/invoice`, {
    params: {
      client_code,
      type,
      voucher_invoice_number,
      operation,
      ...(invoice_id && { invoice_id }),
      ...(supplier_id && { supplier_id }),
      ...(date_of_invoice?.length && { date_of_invoice }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function invoiceGenerationGetComment(
  payload: GetCommentPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, type, invoice_id } = payload;

  return await getData(`invoice-generation/customer/invoice/comments`, {
    params: {
      client_code,
      type,
      invoice_id,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function invoiceGenerationGetCustomerInvoiceDownload(
  payload: GetCommentPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, type, invoice_id } = payload;

  return await getData(`invoice-generation/customer/invoice/download`, {
    params: {
      client_code,
      type,
      invoice_id,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function invoiceGenerationPostComment(
  payload: AddCommentPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, type, invoice_id, comments } = payload;

  let finalData = {
    client_code,
    type,
    invoice_id,
    comments,
  };

  return await postData(
    `invoice-generation/add/customer/invoice/comments`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function invoiceGenerationApproval(
  payload: ApproveInvoicePayloadType
): Promise<AxiosResponse> {
  const { token, client_code, type, invoice_id } = payload;

  let finalData = {
    client_code,
    type,
    invoice_id,
  };

  return await postData(
    `invoice-generation/approve/customer/invoice`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getPaymentPendingApi(
  payload: GetAllocationPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, type, id } = payload;

  return await getData(`invoice-generation/payment/pending/list`, {
    params: {
      client_code,
      type,
      id,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllAllocationListApi(
  payload: GetAllocationPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, type, id } = payload;

  return await getData(`invoice-generation/payment/allocation/list/other-id`, {
    params: {
      client_code,
      other_payment_id: id,
      transaction_type: type,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function invoiceGenerationLockEntryApi(
  payload: LockEntryPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, type, date } = payload;

  let finalData = {
    client_code,
    type,
    date,
  };

  return await postData(`invoice-generation/client/lock`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

//commented for future use
// export async function getEinvoiceApi(
//   payload: EinvoiceDataPayloadType
// ): Promise<AxiosResponse> {
//   const { token, client_code, invoice_id } = payload;

//   return await getData(`invoice-generation/e-invoice/get`, {
//     params: {
//       client_code,
//       invoice_id,
//     },
//     headers: {
//       "Content-Type": "application/json",
//       "user-token": token,
//     },
//   });
// }

export async function getEinvoiceApi(
  payload: EinvoiceDataPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, invoice_id } = payload;

  return await getData(`invoice-generation/e-invoicing/get`, {
    params: {
      client_code,
      invoice_id,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// commented for future use
// export async function getReviewEinvoiceApi(
//   payload: EinvoiceDataPayloadType
// ): Promise<AxiosResponse> {
//   const { client_code, invoice_id, token } = payload;

//   return await getData(`invoice-generation/e-invoice/review-data`, {
//     params: {
//       client_code,
//       invoice_id,
//     },
//     headers: {
//       "Content-Type": "application/json",
//       "user-token": token,
//     },
//   });
// }

export async function getReviewEinvoiceApi(
  payload: EinvoiceDataPayloadType
): Promise<AxiosResponse> {
  const { client_code, invoice_id, token } = payload;

  return await getData(`invoice-generation/e-invoicing/review-data`, {
    params: {
      client_code,
      invoice_id,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getBomListDataApi(
  payload: BomDataListPayloadType
): Promise<AxiosResponse> {
  const {
    clientCode,
    token,
    searchTerm,
    offset,
    limit,
    PrimaryItemIdFilter,
    sortBy,
    sortByValue,
  } = payload;

  return await getData(`/invoice-generation/bill-of-material/list`, {
    params: {
      client_code: clientCode,
      ...(searchTerm && { search_term: searchTerm }),
      offset,
      limit,
      ...(PrimaryItemIdFilter && {
        primary_stock_item_id: PrimaryItemIdFilter,
      }),
      ...(sortBy && { sort_by: sortBy }),
      ...(sortByValue && { sort_by_value: sortByValue }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function bomPostApi(
  payload: BomDataPayloadType
): Promise<AxiosResponse> {
  const {
    clientCode,
    token,
    bomDate,
    primaryStockItemId,
    primaryStockItemName,
    branchId,
    branchName,
    quantity,
    effectiveCostOfPrimaryItem,
    totalAmount,
    totalCostOfInputGoods,
    totalCostOfOutputGoods,
    totalAdditionalCost,
    comment,
    bomInputGoods,
    bomOutputGoods,
    bomAdditionalCosts,
    uploads,
    rateOfPrimaryItem,
    effectiveCost,
    isTemplate,
    templateName,
    primaryBatchNumber
  } = payload;

  let finalData = {
    client_code: clientCode,
    primary_stock_item_id: primaryStockItemId,
    primary_stock_item_name: primaryStockItemName,
    primary_batch_id:primaryBatchNumber,
    branch_id: branchId,
    branch_name: branchName,
    quantity,
    bom_date: bomDate,
    effective_cost_of_primary_item: effectiveCostOfPrimaryItem,
    total_amount: totalAmount,
    total_cost_of_input_goods: totalCostOfInputGoods,
    total_cost_of_output_goods: totalCostOfOutputGoods,
    total_additional_cost: totalAdditionalCost,
    comment,
    bom_input_goods: bomInputGoods,
    bom_output_goods: bomOutputGoods,
    bom_additional_costs: bomAdditionalCosts,
    uploads,
    rate_of_primary_item: rateOfPrimaryItem,
    effective_cost: effectiveCost,
    ...(isTemplate && { is_template: isTemplate }),
    ...(templateName && { template_name: templateName }),
  };

  return await postData(`/invoice-generation/bill-of-material/add`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function bomUpdateApi(
  payload: BomDataPayloadType
): Promise<AxiosResponse> {
  const {
    clientCode,
    token,
    bomDate,
    bomId,
    primaryStockItemId,
    primaryStockItemName,
    branchId,
    branchName,
    quantity,
    effectiveCostOfPrimaryItem,
    totalAmount,
    totalCostOfInputGoods,
    totalCostOfOutputGoods,
    totalAdditionalCost,
    comment,
    bomInputGoods,

    bomOutputGoods,
    bomAdditionalCosts,
    uploads,
    rateOfPrimaryItem,
    effectiveCost,
    primaryBatchNumber
  } = payload;

  let finalData = {
    client_code: clientCode,
    primary_stock_item_id: primaryStockItemId,
    primary_stock_item_name: primaryStockItemName,
    primary_batch_id:primaryBatchNumber,
    branch_id: branchId,
    branch_name: branchName,
    quantity,
    bom_id: bomId,
    bom_date: bomDate,
    effective_cost_of_primary_item: effectiveCostOfPrimaryItem,
    total_amount: totalAmount,
    total_cost_of_input_goods: totalCostOfInputGoods,
    total_cost_of_output_goods: totalCostOfOutputGoods,
    total_additional_cost: totalAdditionalCost,
    comment,
    bom_input_goods: bomInputGoods,
    bom_output_goods: bomOutputGoods,
    bom_additional_costs: bomAdditionalCosts,
    uploads,
    rate_of_primary_item: rateOfPrimaryItem,
    effective_cost: effectiveCost,
  };

  return await postData(
    `/invoice-generation/bill-of-material/update`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

// commented for future use
// export async function eInvoicePostApi(
//   payload: EinvoiceDataPayloadType
// ): Promise<AxiosResponse> {
//   const { client_code, invoice_id, token } = payload;

//   let finalData = {
//     client_code,
//     invoice_id,
//   };

//   return await postData(`invoice-generation/e-invoicing`, finalData, {
//     headers: {
//       "Content-Type": "application/json",
//       "user-token": token,
//       "x-csrf-token": getCSRFToken(),
//     },
//   });
// }

export async function eInvoicePostApi(
  payload: EinvoiceDataPayloadType
): Promise<AxiosResponse> {
  const { client_code, invoice_id, token } = payload;

  let finalData = {
    client_code,
    invoice_id,
  };

  return await postData(`invoice-generation/e-invoicing/generate`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

//commented for future use
// export async function eInvoiceCancelApi(
//   payload: EinvoiceRevertDataPayloadType
// ): Promise<AxiosResponse> {
//   const { client_code, invoice_id, cancel_reason, cancel_remarks, token } =
//     payload;

//   let finalData = {
//     client_code,
//     invoice_id,
//     cancel_reason,
//     cancel_remarks,
//   };

//   return await postData(`invoice-generation/e-invoice/cancel`, finalData, {
//     headers: {
//       "Content-Type": "application/json",
//       "user-token": token,
//       "x-csrf-token": getCSRFToken(),
//     },
//   });
// }

export async function eInvoiceAuthenticationPostApi(
  payload: EinvoiceAuthenticationDataPayloadType
): Promise<AxiosResponse> {
  const { userName, password, gstin, clientCode, token } = payload;

  let finalData = {
    username: userName,
    password,
    gstin,
    client_code: clientCode,
  };

  return await postData(`quicko-e-invoice/authentication`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function eInvoiceCancelApi(
  payload: EinvoiceRevertDataPayloadType
): Promise<AxiosResponse> {
  const { client_code, invoice_id, cancel_reason, cancel_remarks, token } =
    payload;

  let finalData = {
    client_code,
    invoice_id,
    cancel_reason,
    cancel_remarks,
  };

  return await postData(`invoice-generation/e-invoicing/cancel`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function sendOverdueEmailApi(
  payload: SendOverdueEmailPayloadType
): Promise<AxiosResponse> {
  const { clientCode, attachment, invoiceId, token, type, emailId } = payload;

  let finalData = {
    email_id: emailId?.trim(),
    attachment: attachment,
    client_code: clientCode,
    invoice_id: invoiceId,
    type,
  };

  return await postData(`notification-module/invoice-payment`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getInvoiceNotesListApi(
  payload: InvoiceNotesPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, type, ledger_id } = payload;

  let finalData = {
    client_code,
    type,
    ledger_id,
  };

  return await getData(`invoice-generation/invoice/notes`, {
    params: {
      ...finalData,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getSingleBomDataApi(
  data: SingleBomDataPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, bom_id } = data;

  const finalParams = {
    client_code,
    bom_id,
  };
  return await getData(`/invoice-generation/bill-of-material/details`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function getSingleBomTemplateDataApi(
  data: SingleBomDataPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, templateId } = data;

  const finalParams = {
    client_code,
    template_id: templateId,
  };
  return await getData(`invoice-generation/bill-of-material/template/details`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getBOMSavedTemplateListApi(
  data: BomDataListPayloadType
): Promise<AxiosResponse> {
  const {
    clientCode,
    token,
    searchTerm,
    offset,
    limit,
    PrimaryItemIdFilter,
    sortBy,
    sortByValue,
    branchId,
  } = data;

  return await getData(`invoice-generation/bill-of-material/template/list`, {
    params: {
      client_code: clientCode,
      ...(searchTerm && { search_term: searchTerm }),
      offset,
      limit,
      ...(PrimaryItemIdFilter && {
        primary_stock_item_id: PrimaryItemIdFilter,
      }),
      ...(sortBy && { sort_by: sortBy }),
      ...(sortByValue && { sort_by_value: sortByValue }),
      ...(branchId && { branch_id: branchId }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getInvoiceHistoryApi(
  data: InvoiceHistoryPayloadType
): Promise<AxiosResponse> {
  const { invoiceType, clientCode, invoiceId, token, limit, offset } = data;

  return await getData(`history/invoice`, {
    params: {
      client_code: clientCode,
      invoice_type: invoiceType,
      invoice_id: invoiceId,
      limit,
      offset,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getOthersInvoiceHistoryApi(
  data: InvoiceHistoryPayloadType
): Promise<AxiosResponse> {
  const { clientCode, invoiceId, token, limit, offset } = data;

  return await getData(`history/others/invoice`, {
    params: {
      client_code: clientCode,
      others_invoice_id: invoiceId,
      limit,
      offset,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function uniqueCheckBOMSavedTemplateNameApi(
  data: UniqueCheckBomTemplateNamePayloadType
): Promise<AxiosResponse> {
  const { clientCode, token, templateName } = data;

  return await getData(
    `invoice-generation/bill-of-material/template/name-unique-check`,
    {
      params: {
        client_code: clientCode,
        template_name: templateName,
      },
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}

export async function getReviewEWayBillApi(
  payload: EWayBillDataPayloadType
): Promise<AxiosResponse> {
  const { client_code, invoice_id, token, invoice_type, type } = payload;

  return await getData(`invoice-generation/e-way-bill/review/details`, {
    params: {
      client_code,
      invoice_id,
      invoice_type,
      type,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getGenerateEWayBillApi(
  data: GenerateEWayBillPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    invoice_id,
    invoice_type,
    sub_supply_type,
    transporter_id,
    transporter_name,
    transporter_document_number,
    transporter_document_date,
    transportation_mode,
    transportation_distance,
    vehicle_number,
    vehicle_type,

    type,
    transaction_type,
  } = data;

  let finalData = {
    client_code,
    invoice_id,
    invoice_type,
    sub_supply_type,
    transporter_id,
    transporter_name,
    transporter_document_number,
    transporter_document_date,
    transportation_mode,
    transportation_distance,
    vehicle_number,
    vehicle_type,
    type,
    transaction_type,
  };

  return await postData(`invoice-generation/generate/e-way-bill`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function eWayBillCancelApi(
  payload: EWayBillCancelDataPayloadType
): Promise<AxiosResponse> {
  const {
    client_code,
    invoice_id,
    reason_of_cancel,
    cancel_remarks,
    invoice_type,
    token,
    type,
  } = payload;

  let finalData = {
    client_code,
    invoice_id,
    invoice_type,
    cancel_remarks,
    reason_of_cancel,
    type,
  };

  return await postData(`invoice-generation/cancel/e-way-bill`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function postGenerateEWayBillApi(
  data: ExtendEWayBillPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    invoice_id,
    invoice_type,
    remaining_distance,
    extend_validity_reason,
    extend_remarks,
    from_pincode,
    consignment_status,
    transit_type,
    address_line1,
    address_line2,
    address_line3,
    transporter_document_date,
    transporter_document_number,
    mode_of_transport,
    vechile_number,
    current_place_of_consignor,
    current_state_of_consignor,
    type,
  } = data;

  let finalData = {
    client_code,
    invoice_id,
    invoice_type,
    remaining_distance,
    current_place_of_consignor,
    current_state_of_consignor,
    vechile_number,
    transporter_document_date,
    transporter_document_number,
    mode_of_transport,
    extend_validity_reason,
    extend_remarks,
    from_pincode,
    consignment_status,
    transit_type,
    address_line1,
    address_line2,
    address_line3,
    type,
  };

  return await postData(`invoice-generation/extend/e-way-bill`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function checkDistanceCountApi(
  data: DistanceCountPayloadType
): Promise<AxiosResponse> {
  const { token, from_pincode, to_pincode } = data;
  const finalParams = {
    from_pincode,
    to_pincode,
  };

  return await getData(`invoice-generation/e-way-bill/get/distance`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function eWayBillAuthenticationPostApi(
  payload: EinvoiceAuthenticationDataPayloadType
): Promise<AxiosResponse> {
  const { userName, password, gstin, clientCode, token } = payload;

  let finalData = {
    username: userName,
    password,
    gstin,
    client_code: clientCode,
  };

  return await postData(`quicko-e-way-bill/authentication`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function invoiceGenerationLockEntryBOMApi(
  payload: LockEntryBomPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, date } = payload;

  let finalData = {
    client_code,
    date,
  };

  return await postData(
    `invoice-generation/manufacturing-journal/lock`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}
export async function downloadManufacturalJournalReportsApi(
  data: DownloadManufacturalJournalReportType
): Promise<AxiosResponse> {
  const { token, client_code, start_date, end_date } = data;

  return await getData(`invoice-generation/bill-of-material/details/download`, {
    params: {
      client_code,
      start_date,
      end_date,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function updateVehicleEWayBillDetailsApi(
  data: UpdateEWayBillPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    client_code,
    invoice_id,
    invoice_type,
    vehicle_number,
    from_state,
    from_place,
    update_reason_remarks,
    transporter_document_number,
    transporter_document_date,
    transportation_mode,
    vehicle_type,
    reason_of_update,
    type,
  } = data;

  let finalData = {
    client_code,
    invoice_id,
    invoice_type,
    vehicle_number,
    from_state,
    from_place,
    update_reason_remarks,
    transporter_document_number,
    transporter_document_date,
    transportation_mode,
    vehicle_type,
    reason_of_update,
    type,
  };

  return await putData(
    `invoice-generation/update/vehicle-details/e-way-bill`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateTransporterEWayBillDetailsApi(
  data: UpdateTrasporterEWayBillPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, invoice_id, invoice_type, transporter_id, type } =
    data;

  let finalData = {
    client_code,
    invoice_id,
    invoice_type,
    transporter_id,
    type,
  };

  return await putData(
    `invoice-generation/update/transporter-detail/e-way-bill`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getClientColumnAssignedApi(
  data: GetClientColumnAssignedPayloadType
): Promise<AxiosResponse> {
  const { client_code, token } = data;

  return await getData(`invoice-generation/check/client/column/assign`, {
    params: {
      client_code,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getGstr2a2bComparePayloadApi(
  data: GetGstrTwoATwoBComparePayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, gstNumber, month, year, type, invoiceNumber } =
    data;
  const finalData = {
    client_code: clientCode,
    gst_number: gstNumber,
    month,
    year,
    type,
    invoice_number: invoiceNumber,
  };
  return getData("gst/get/add/gstr-2a/gstr-2b/invoice/payload", {
    params: { ...finalData },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
